/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
const bugsnag = require('@bugsnag/js')

require('./bootstrap');

window.Vue = require('vue');
window.bugsnagClient = bugsnag('d93a1eb93fe53c4853a4617652f5d9b5')

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('multiselect-component', require('./components/MultiselectComponent.vue').default);
Vue.component('datepicker-component', require('./components/DatepickerComponent.vue').default);
Vue.component('upload-component', require('./components/UploadComponent.vue').default);
Vue.component('chart-component', require('./components/ChartComponent.vue').default);
Vue.component('avatar-component', require('./components/AvatarComponent.vue').default);
Vue.component('select-year', require('./components/SelectYearComponent.vue').default);
Vue.component('select-month', require('./components/SelectMonthComponent.vue').default);
Vue.component('select-ranking', require('./components/SelectRankingComponent.vue').default);
Vue.component('change-permission', require('./components/ChangePermissionComponent.vue').default);
Vue.component('pige-component', require('./components/PigeComponent.vue').default);
Vue.component('answer-component', require('./components/AnswerComponent.vue').default);
Vue.component('upload-area', require('./components/UploadAreaComponent.vue').default);
Vue.component('questions-component', require('./components/QuestionsComponent.vue').default);
Vue.component('booking-component', require('./components/BookingComponent.vue').default);
Vue.component('course-component', require('./components/CourseComponent.vue').default);
Vue.component('video-player-component', require('./components/VideoPlayerComponent.vue').default);
Vue.component('invoice-status-select', require('./components/InvoiceStatusSelect.vue').default)
Vue.component('doughnut-chart', require('./components/DoughnutChart.vue').default)
Vue.component('transfers-list', require('./components/TransfersList.vue').default)
Vue.component('invoices-downloader', require('./components/InvoicesDownloader.vue').default)
Vue.component('sector-component', require('./components/SectorComponent.vue').default)
Vue.component('company-selector', require('./components/CompanySelector.vue').default)

import VuePlyr from 'vue-plyr'

Vue.use(VuePlyr, {
  plyr: {
    debug: false,
    fullscreen: { enabled: false },
    controls: [
      'play-large', // The large play button in the center
      'play', // Play/pause playback
      'current-time', // The current time of playback
      'duration', // The full duration of the media
      'mute', // Toggle mute
      'volume', // Volume control
      'settings', // Settings menu
      'fullscreen', // Toggle fullscreen
    ]
  },
  emit: ['ended']
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
